<template>
    <div class="p-search-modal__btns-area">
        <button v-if="totalMovies > 0" type="button" class="p-search-modal__tab-btn" :class="moviesActive"  @click="emitCurrentActive('movie')">{{titles.movies}} <span>{{totalMovies}}</span></button>
        <button v-if="totalArticles > 0" type="button"  class="p-search-modal__tab-btn" :class="articlesActive"  @click="emitCurrentActive('article')">{{titles.articles}} <span>{{totalArticles}}</span></button>
    </div>
</template>

<script setup>
import {computed} from "vue"
const props = defineProps({
    totalMovies: {default: 0, type: Number},
    totalArticles: {default: 0, type: Number},
    modelValue: {default: 'movie', type: String},
    titles: {
        default: ()=>{return {
            movies: "",
            articles: ""
        }},
        type: Object
    }
})

const moviesActive = computed(()=>{
    return props.modelValue === 'movie' ? 'p-search-modal__tab-btn--active' : ''
})

const articlesActive = computed(()=>{
    return props.modelValue === 'article'|| props.totalMovies==0 ? 'p-search-modal__tab-btn--active' : ''
})


const emit = defineEmits(['update:modelValue'])

const emitCurrentActive = (selectedButton) =>{
    emit('update:modelValue', selectedButton)
}
</script>